// Trwały identyfikator urządzenia, przechowywany w cookie. Służy jako klucz limitu 3 urządzeń
// po stronie backendu i pozwala wylogować konkretne urządzenie z poziomu /profile.
// Cookie (a nie localStorage), bo ma być trwałe per-urządzenie/przeglądarka i niezależne od trybu
// "zapamiętaj mnie" — czyszczenie sesji nie usuwa identyfikatora urządzenia.

const COOKIE_NAME = 'device_id';
const MAX_AGE_SECONDS = 400 * 24 * 60 * 60; // ~400 dni (górny limit trwałości cookie w przeglądarkach)

function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  const parts = document.cookie ? document.cookie.split('; ') : [];
  for (const part of parts) {
    if (part.startsWith(prefix)) return decodeURIComponent(part.slice(prefix.length));
  }
  return null;
}

function writeCookie(name: string, value: string): void {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
}

function generateUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback dla starszych środowisk bez crypto.randomUUID.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Zwraca identyfikator urządzenia; tworzy go i zapisuje w cookie przy pierwszym wywołaniu.
export function getDeviceId(): string {
  let id = readCookie(COOKIE_NAME);
  if (!id) {
    id = generateUuid();
    writeCookie(COOKIE_NAME, id);
  } else {
    // Odśwież TTL przy każdym użyciu, żeby aktywne urządzenie nie traciło identyfikatora.
    writeCookie(COOKIE_NAME, id);
  }
  return id;
}
